import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import languageReducer from "./Slices/LangSlice";

const SUPPORTED_LANGUAGES = ["en", "fr"];

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["language"],
  // Purane users ke browser me agar "ar" (ya koi galat value) saved hai to use "en" bana do.
  // Dhyan: yahan `state.language` seedha string hai ("en"/"fr"), object nahi.
  migrate: (state) => {
    if (state && !SUPPORTED_LANGUAGES.includes(state.language)) {
      return Promise.resolve({ ...state, language: "en" });
    }
    return Promise.resolve(state);
  },
};

const persistedLanguageReducer = persistReducer(
  persistConfig,
  languageReducer
);

export const store = configureStore({
  reducer: {
    language: persistedLanguageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);